<!DOCTYPE html>
<div class="iframe">
    <mat-icon class="close-icon" color="black" (click)="closeDialog()">close</mat-icon>
    <iframe [src]="faqLink" width="100%" height="100%" frameBorder="0" allowfullscreen="allowfullscreen"></iframe>
</div>
